<template>
  <div>
    <PageTitle>
      <span v-html="$store.state.app.pageName" />
    </PageTitle>

    <PageContent v-if="documents.length === 0">
      <Container>
          <NoticeBox
            type="error"
            :borderless="true"
            class="space-b-2 text-bold"
          >
            現在、書類がありません
          </NoticeBox>
          <p class="text-paragraph text-xs">
            現在表示される書類がありません。
            <br class="mobile-only" />
            書類がある場合は、この画面に表示されます。
          </p>
          <div class="text-center space-t-6">
            <router-link
              :to="$wcRouter.path({ name: 'index' })"
              class="button waves-effect waves-light"
            >
              TOPへ
            </router-link>
          </div>
        </Container>
    </PageContent>

    <PageContent v-else :top-sticked="true">
      <Container :mobile-fluid="true">
        <ul class="list-group">
          <li
            v-for="(doc, index) in documents"
            :key="index"
            class="list-group-item"
          >
            <div class="list-group-text text-xs">
              <div class="vertical-center">
                <div class="flex-0 space-r-2">
                  {{ doc.created | formatDate }}
                </div>
                <div
                  class="flex-1 vertical-center"
                  :class="[`doc-name-${doc.document_type}`]"
                >
                  <p class="flex-0 icon space-r-half">
                    <i :class="iconClass(doc.document_type)" />
                  </p>
                  <p class="flex-1 text-paragraph">
                    {{ $domUtils.decode(doc.document_name) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="list-group-control">
              <a
                :href="doc.download_url"
                @click.prevent="download(doc)"
              >
                <i class="fas fa-download" />
              </a>
            </div>
          </li>
        </ul>
      </Container>
    </PageContent>
  </div>
</template>

<script>
import moment from 'moment'
import url from 'url'
import { saveAs } from 'file-saver'
import api from '@/api/document'
import { renderError } from '@/utils/error'
import { formatDate } from '@/filters/format-date'
import NoticeBox from '@/components/NoticeBox.vue'
import { URL_EXPIRED } from '@/messages/errors'

const DISPLAY_NAME_SEPARATOR = ' - '

export default {
  components: {
    NoticeBox,
  },

  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'document' }
    }
  },

  data() {
    return {
      documents: [],
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
  },

  filters: {
    formatDate,
  },
  methods: {
    iconClass(type) {
      return {
        'fas': type === 1 || type === 3 || type === 4,
        'far': type === 2,
        'fa-calculator': type === 1,
        'fa-file-alt': type === 2,
        'fa-money-bill-alt': type === 3,
        'fa-file': type === 4,
      }
    },
    async fetchDocuments() {
      try {
        this.documents = await api.index(this.businessId)
      } catch(err) {
        renderError(err)
      }
    },
    download(doc) {
      const urlStr = doc.download_url
      if (this.isSignedUrlExpired(urlStr)) {
        // 署名付きURLの有効期限が切れている場合は画面リロードさせる
        alert(URL_EXPIRED)
        window.location.reload()
        return
      }
      saveAs(urlStr, this.downloadFileName(doc))
    },
    downloadFileName(doc) {
      const current = moment().format('YYYYMMDDHHmmss')
      const type = doc.document_type
      // 成約書、請求書が追加された場合typeで分岐するよう修正予定
      if (type === 4) {
        return `その他_${current}.pdf`
      }
      if (type === 3) {
        return `ご請求_${current}.pdf`
      }
      if (type === 2) {
        return `${this.downloadFileNamePrefix(doc.document_name)}_${current}.pdf`
      }
      return `お見積書_${current}.pdf`
    },
    downloadFileNamePrefix(documentName) {
      const decodedDocumentName = this.$domUtils.decode(documentName)
      return decodedDocumentName.split(DISPLAY_NAME_SEPARATOR)[0]
    },
    isSignedUrlExpired(urlStr) {
      let urlInfo = url.parse(urlStr, true)
      return (urlInfo.query.Expires < moment().unix())
    }
  },

  created() {
    this.$withLoading(this.fetchDocuments)
  },
}
</script>
